const target = '_blank';
const options = 'clearcache=yes,clearsessioncache=yes,location=no';

export default {
    target: target,
    options: options,
};
